<template>
    <section class="c-cta-complex">
        <div class="c-cta-complex__content">
            <components
                :is="titleTag"
                v-if="title"
                class="content-title"
                v-text="title"
            />
            <p
                v-if="description"
                class="content-description"
                v-text="description"
            />
            <div class="content-actions">
                <div
                    v-if="solidBtnTitle"
                    class="banner-btn-solid"
                >
                    <y-button
                        v-if="!solidButtonClass"
                        color="primary"
                        :disabled="disableCtaBtn"
                        :tag="checkTagName(solidBtnLink)"
                        :to="solidBtnLink"
                        :href="solidBtnLink"
                        :content="solidBtnTitle"
                        size="medium"
                        flat
                        :no-padding="true"
                    />
                    <y-button
                        v-else
                        :class="{[solidButtonClass]: !!solidButtonClass}"
                        color="primary"
                        size="medium"
                        :content="solidBtnTitle"
                        flat
                        :no-padding="true"
                    />
                </div>
                <div
                    v-if="outlinedBtnTitle"
                    class="banner-btn-border"
                >
                    <y-button
                        color="transparent"
                        :disabled="disableCtaBtn"
                        :tag="checkTagName(outlinedBtnLink)"
                        :to="outlinedBtnLink"
                        :href="outlinedBtnLink"
                        :content="outlinedBtnTitle"
                        size="medium"
                        flat
                        :no-padding="true"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="imageSrc && (hasImageInMobile || $mq === 'lg' || $mq === 'xlg')"
            class="c-cta-complex__image-container"
        >
            <img
                :src="imgSrc(imageSrc)"
                :alt="title"
                class="cta-img"
                height="272"
                width="263"
            >
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';
    import Components from '@modules/landing/components/Components/Index.vue';

    export default {
        name      : 'ForPagesCtaComplex',
        components: { Components },

        props: {
            title: {
                type: String,
            },
            description: {
                type: String,
            },
            solidBtnLink: {
                type: String,
            },
            solidBtnTitle: {
                type: String,
            },
            outlinedBtnLink: {
                type: String,
            },
            outlinedBtnTitle: {
                type: String,
            },
            imageSrc: {
                type: Object,
            },
            hasImageInMobile: Boolean,
            disableCtaBtn   : Boolean,
            titleTag        : {
                default: 'h3',
                type   : String,
            },
            solidButtonClass: String,

        },
        methods: {
            isLink,
            /**
             *
             * check tag name
             *
             * @param {string} link
             * @returns {string}
             */
            checkTagName(link) {
                if (this.disableCtaBtn) {
                    return 'button';
                }
                return isLink(link) ? 'a' : 'router-link';
            },
        },
    };
</script>

<style lang="scss" src="./cta-complex.scss"></style>
